import React, { Component } from "react";
import { connect } from "react-redux";
import { getLastUpdates } from "../actions/filesActions";
import SearchField from "./SearchField";
import LastUpdates from "./LastUpdates";
import Instructions from "./Instructions";
import MailingListSubscrib from "./MailingListSubscrib";
import { Container, Row, Col, Media } from "reactstrap";
import { joinCss } from "../helpers/utils";

import classes from "./Home.module.scss";

import background from "../images/homeHeader.png";
import backgroundMobile from "../images/homeHeaderMobile.png";

class Home extends Component {
  constructor() {
    super();
    this.state = {
      lastUpdates: [],
      mdSize: false
    };
  }

  updateDimensions() {
    if (window.innerWidth <= 992 || window.screen.width <= 992) {
      this.setState({ mdSize: true });
    } else {
      this.setState({ mdSize: false });
    }
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.props.onLoadData();
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lastUpdates != null) {
      this.setState({ lastUpdates: nextProps.lastUpdates });
    }
  }

  render() {
    return (
      <Container>
        <Row>
          <Col className={joinCss("px-0", classes.homeImgCol)}>
            <Media
              src={this.state.mdSize ? backgroundMobile : background}
              alt="תמונת רקע"
              className={classes.homeImg}
            />
            <Container className={classes.topContainer}>
              <Row>
                <Col xl="6" lg="12">
                  <SearchField />
                </Col>
                <Col xl="6" lg="12">
                  <LastUpdates updates={this.state.lastUpdates} />
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <div className="clearfix" />
        <Row>
          <Col className="px-0">
            <Instructions />
          </Col>
        </Row>
        <Row>
          <Col className="px-0">
            <MailingListSubscrib />
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    lastUpdates: state.files.lastUpdates
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLoadData: () => dispatch(getLastUpdates())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
